import { createFileRoute, notFound } from '@tanstack/react-router';
import { isValidSubNav, type SubnavParam } from './-utils';

type Params = {
  subNav: SubnavParam;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/bulk_/$subNav')({
  params: {
    parse: (params): Params => {
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      return {
        ...params,
        subNav: params.subNav,
      };
    },
  },
});
